import React, { useEffect, useState, useRef } from "react";
import logo from "./images/neo_black.svg";
import neoVinci from "./images/logo_neo.svg";
import headerImg from "./images/header.png";
import {
  Box,
  CircularProgress,
  Container,
  Grid,
} from "@mui/material";
import { Link } from "react-router-dom";
import { ROUTES_CORE } from "commons/constants/paths";
import {
  StyledHeaderSection,
  StyledHeaderImg,
  StyledHeaderHolder,
  StyledHeaderTitle,
  StyledHeaderSubtitle,
  StyledSectionTitle,
  StyledInfoSectionDescription,
  StyledAnchor,
  StyledLogo,
  StyledNavbarList,
  StyledNavbarListItem,
  StyledFooter,
  StyledFooterSection,
  StyledFooterTitle,
  StyledFooterMenu,
  StyledFooterMenuLink,
  StyledFooterImg,
  StyledFooterImgSpan,
  StyledContactWayTitle,
  StyledButtonPrimary,
} from "./Home.styled";
import { useAppDispatch, useAppSelector } from "commons/store/hooks";
import { PROJECT_EMAIL, PROJECT_NAME } from "commons/constants/env";
import { fetchPageData, selectPageData } from "../../../redux/pageSlice";

function Home() {
  const dispatch = useAppDispatch();
  const page = useAppSelector(selectPageData);
  const [isDataLoading, setDataLoading] = useState(false);
  let info: any = useRef();

  /**
   * Used to fetch page data
   */
  const fetchData = async () => {
    setDataLoading(true);

    const pageData = await dispatch(fetchPageData('home'))?.unwrap();

    if (!pageData) {
      // return;
    }

    setDataLoading(false);
  }

  useEffect(() => {
    // fetchData().then();
  }, []);

  /** Tab title controller */
  useEffect(() => {
    document.title = `${PROJECT_NAME} - Strona Główna`;
    return () => {
      document.title = PROJECT_NAME;
    };
  }, [dispatch]);

  return (
    <div>
      {isDataLoading && (
        <Box display="grid" style={{placeItems: 'center', height: '100vh'}}>
          <Box display="grid" style={{placeItems: 'center', gap: '15px'}}>
            <CircularProgress />
          </Box>
        </Box>
      )}

      {!isDataLoading && (<>
      <header>
        <Container maxWidth="lg">
          <Grid container spacing={0} direction="row" justifyContent="space-between" alignItems="center" style={{ minHeight: '70px' }}>
            <Grid container item lg={3} xs={12} spacing={0}>
               <StyledLogo src={logo} alt="Projekt logo" />
            </Grid>
            <Grid container item lg={9} xs={12} spacing={0}>
              <StyledNavbarList>
                <StyledNavbarListItem>
                  <StyledButtonPrimary
                    onClick={() =>
                      window.scrollTo({
                        behavior: "smooth",
                        top: info.current.offsetTop,
                      })
                    }
                    size="medium"
                  >
                    Informacje o badaniu
                  </StyledButtonPrimary>
                </StyledNavbarListItem>
                <StyledNavbarListItem>
                  <StyledButtonPrimary
                    variant="contained"
                    color="primary"
                    to={ROUTES_CORE.LOGIN}
                    component={Link}
                  >
                    LOGOWANIE
                  </StyledButtonPrimary>
                </StyledNavbarListItem>
                <StyledNavbarListItem>
                  <StyledButtonPrimary
                    variant="contained"
                    color="primary"
                    to={ROUTES_CORE.REGISTER}
                    component={Link}
                  >
                    REJESTRACJA
                  </StyledButtonPrimary>
                </StyledNavbarListItem>
              </StyledNavbarList>
            </Grid>
          </Grid>
        </Container>
      </header>

      <StyledHeaderSection>
        <StyledHeaderImg src={headerImg} alt="Background img"/>
        <StyledHeaderHolder>
          <Container maxWidth="lg">
            <StyledHeaderTitle>
              Badanie konsumenckie kolagenu Remé
            </StyledHeaderTitle>
            <StyledHeaderSubtitle>
              Ogólnopolskie badanie konsumenckie stworzone, by lepiej zrozumieć potrzeby skóry i skuteczność naszej Formuły Piękna.
              Remé to suplement diety nowej generacji, oparty na peptydach kolagenowych VERISOL®
              oraz zestawie witamin i minerałów wspierających naturalne piękno. W ramach projektu badawczego przeprowadzamy
              3-miesięczną obserwację doświadczeń osób stosujących produkt.
            </StyledHeaderSubtitle>
            <br/>
          </Container>
        </StyledHeaderHolder>
      </StyledHeaderSection>
      <section ref={info}>
        <Container maxWidth="lg">
          <StyledSectionTitle textAlign="center">
            Informacje o badaniu
          </StyledSectionTitle>
          <StyledInfoSectionDescription textAlign="left">
            Celem badania jest zebranie opinii oraz zdjęć twarzy wykonywanych wyłącznie na potrzeby analizy działania produktu.<br/><br/>
            Ocenie poddane zostaną:
            <ul style={{ paddingLeft: "20px" }}>
              <li>
                parametry skóry, włosów i paznokci
              </li>
              <li>
                właściwości użytkowe produktu
              </li>
            </ul>
            <br/>
            Dlaczego prowadzimy badanie?<br/><br/>
            Skuteczność ma dla nas znaczenie wtedy, gdy jest widoczna w Twoim lustrze.
            Dlatego stworzyliśmy projekt badawczy Remé – by zebrać autentyczne opinie od osób,
            które stosują naszą Formułę Piękna w codziennej rutynie pielęgnacyjnej.
            <br/>
          </StyledInfoSectionDescription>
          {/*<MedicalCenter />*/}
        </Container>
      </section>

      <StyledFooter>
        <Container maxWidth="lg">
          <StyledFooterSection>
            <Grid container spacing={1} direction="row" justifyContent="space-between" alignItems="center">
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <StyledFooterTitle>Menu:</StyledFooterTitle>
                <StyledFooterMenu>
                  <StyledFooterMenuLink onClick={() =>
                    window.scrollTo({
                      behavior: "smooth",
                      top: info.current.offsetTop,
                    })
                  }>
                    INFORMACJE O BADANIU
                  </StyledFooterMenuLink>
                </StyledFooterMenu>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <StyledFooterTitle>Kontakt:</StyledFooterTitle>
                <StyledContactWayTitle>e-mail: </StyledContactWayTitle>
                <StyledAnchor href={`mailto:${PROJECT_EMAIL}`}>
                  {PROJECT_EMAIL}
                </StyledAnchor>
                <br/>
                {/*<StyledContactWayTitle>telefon: </StyledContactWayTitle>*/}
                {/*<StyledFooterAnchor href={`tel:${PROJECT_PHONE}`}>*/}
                {/*  {PROJECT_PHONE}*/}
                {/*</StyledFooterAnchor>*/}
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <StyledFooterTitle>Dostęp do systemu:</StyledFooterTitle>
                <Box display="flex" justifyContent="flex-start">
                  <StyledButtonPrimary
                    variant="contained"
                    color="primary"
                    to={ROUTES_CORE.LOGIN}
                    component={Link}
                  >
                    LOGOWANIE
                  </StyledButtonPrimary>
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={2}>
                <StyledFooterImgSpan>Organizator techniczny badania::</StyledFooterImgSpan>
                <Box display="grid" justifyContent="flex-start">
                  <StyledFooterImg src={neoVinci} alt="Neo-Vinci logo"/>
                </Box>
              </Grid>
            </Grid>
          </StyledFooterSection>
        </Container>
      </StyledFooter>
      </>
    )}
    </div>
  );
}

export default Home;
